export default __webpack_public_path__ + "static/bubble_deco2-c39384d9c356345f8a7db810369e0c0b.png";